import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import auth from './modules/auth';
import requestField from './modules/requestField';
import operatorScripts from '@/store/modules/OperatorScript';
import psk from '@/store/modules/psk';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    modalContent:'',
    modalFlag:false,
    modalBlocker:true,
    pauseAutoDealer:false,
    // token:''
  },
  getters:{
  },
  mutations: {
    setContent: function (state, value) {
      state.modalContent = value;
    },
    showModal: function (state) {
      state.modalFlag = true;
    },
    hideModal: function (state) {
      state.modalFlag = false;
    },
    userCanCloseModal: function (state) {
      state.modalBlocker = true;
      // console.log('userCanCloseModal')
    },
    userCanNotCloseModal: function (state) {
      state.modalBlocker = false;
      // console.log('userCanNotCloseModal')
    },
    onPauseAutoDealer: function (state, value) {
      state.pauseAutoDealer = value;
    }

  },
  actions: {

  },
  modules:{
    user,
    auth,
    requestField,
    operatorScripts,
    psk
  }
})
